import React, { Component } from "react";
import Navbar from "../navbar/navbar.js";
import "../login/login.css";

class Signup extends Component {
  render() {
    return (
      <div>
        <Navbar />
        <div className="login-form">
          <h1>Sign up as an</h1>
            <a href={"https://influence.espireads.com/signup"} className="log-btn">Affiliate</a>
            <a href={"https://influence.espireads.com/advertiser_signup"} className={"log-btn"}>Advertiser</a>
        </div>
      </div>
    );
  }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/components/signup/signup.js